import { Text, UseDisclosureReturn } from "@chakra-ui/react";
import { AccountAccessInvite } from "@syla/shared/types/responses/GetAccountsResponse";
import React from "react";
import { ConfirmActionModal } from "../../../components/modals/ConfirmActionModal";
import { useMutationUpdateAccountInvites } from "../../../store/useMutationUpdateAccountInvites";

export function CancelAccountInviteModal({
  accountId,
  accountInvite,
  disclosure,
}: {
  accountId: string;
  accountInvite: AccountAccessInvite;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const mutationUpdateAccountInvites =
    useMutationUpdateAccountInvites(accountId);

  const cancelInvite = async () => {
    await mutationUpdateAccountInvites.mutateAsync({
      ops: [
        {
          action: "delete",
          email: accountInvite.email,
        },
      ],
    });
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title="Cancel account invite"
      confirmButtonText="Cancel invite"
      colorScheme="red"
      onConfirm={cancelInvite}
    >
      <Text mb={4}>
        This will cancel the invite for{" "}
        <Text as="span" fontWeight="bold">
          {accountInvite.email}
        </Text>
        .
      </Text>
      <Text color="gray.600">
        They will no longer be able to accept this invite to access the account.
      </Text>
    </ConfirmActionModal>
  );
}
